module.exports = __webpack_public_path__ + "media/src/images/page01_student_input-ecd492811a57994ab5c383f21c749289.gif";